<template>
  <div v-if="category.productgroups.length > 0">
    <div :class="ticketGroupClass">
      <div>
        <h2 class="ticket-toggle-main-tit" :tabindex="category.passgroup_type === 'wavve' ? 0 : ''">
          <span>{{ isOksusu ? '프로모션 이용권' : category.passgroup_name }}</span>
          <button v-if="category.passgroup_type === 'wavve'" @click.prevent="openPopup" type="button" class="btn-ticket-intro">이용권 소개 팝업</button>
        </h2>
        <button type="button" v-if="isEtcVoucher" @click="toggleVoucher" class="btn-ticket-toggle">기타요금제 토글</button>
      </div>
      <all-product-groups v-for="(data, index) in category.productgroups"
                          :key="''+categoryNum+index"
                          :productGroups="data"
                          :categoryNum="categoryNum"
                          :productGroupNum="''+categoryNum+index"
                          :voucher-type="category.passgroup_type"
                          :current-index="currentIndex"
                          :is-oksusu="isOksusu"
                          :current-product-name="currentProductName"
                          :voucher-name="category.passgroup_name"
      />
    </div>
    <voucher-guide :voucherType="category.passgroup_type"/>
    <voucher-info-popup :is-show="isVisibleVoucherInfoPopup" :close-fn="closePopup"></voucher-info-popup>
  </div>
</template>

<script>
import AllProductGroups from '@/components/voucher/AllProductGroups'
import queryString from '@/common/utils/querystring'
import VoucherGuide from '@/components/voucher/VoucherGuide'
import VoucherInfoPopup from '@/components/voucher/VoucherInfoPopup'
import _ from 'lodash'
export default {
  components: {
    VoucherInfoPopup,
    AllProductGroups,
    VoucherGuide
  },
  props: {
    category: {
      type: Object,
      required: true
    },
    categoryNum: {
      type: Number,
      required: true
    },
    currentIndex: {
      type: String
    },
    isOksusu: {
      type: Boolean
    },
    currentProductName: {
      type: String
    }
  },
  data () {
    return {
      isVisibleVoucherInfoPopup: false,
      isEtcVoucher: false,
      isShowEtcVoucher: false
    }
  },
  computed: {
    ticketGroupClass () {
      return ((this.isShowEtcVoucher && this.isEtcVoucher) || !this.isEtcVoucher) ? 'ticket-group' : 'ticket-group closed'
    }
  },
  methods: {
    openPopup () {
      this.isVisibleVoucherInfoPopup = true
    },
    closePopup () {
      this.isVisibleVoucherInfoPopup = false
    },
    toggleVoucher () {
      this.isShowEtcVoucher = !this.isShowEtcVoucher
    }
  },
  mounted () {
    let scroll = queryString.getQueryParamValue(this.$route, 'scroll')
    let scrollElement = document.getElementById(scroll)
    if (scrollElement) {
      window.onload = function () {
        window.scroll(0, scrollElement.offsetTop + 260)
      }
    }
  },
  created () {
    this.isEtcVoucher = _.get(this.category, 'passgroup_type', '') === 'etc'
  }
}
</script>
